import React from 'react';
import Flags from 'country-flag-icons/react/3x2';
import Select from 'react-select';

import styles from './countrySelect.module.scss';

const countryList = [
  { name: 'Argentina', code: 'AR', char: '🇦🇷', region: 'argentina' },
  { name: 'Brasil', code: 'BR', char: '🇧🇷', region: 'brasil' },
  { name: 'Chile', code: 'CL', char: '🇨🇱', region: 'chile' },
  { name: 'Colombia', code: 'CO', char: '🇨🇴', region: 'colombia' },
  { name: 'Costa Rica', code: 'CR', char: '🇨🇷', region: 'costarica' },
  { name: 'Ecuador', code: 'EC', char: '🇪🇨', region: 'ecuador' },
  { name: 'El Salvador', code: 'SV', char: '🇸🇻', region: 'elsalvador' },
  { name: 'Guatemala', code: 'GT', char: '🇬🇹', region: 'guatemala' },
  { name: 'Honduras', code: 'HN', char: '🇭🇳', region: 'honduras' },
  { name: 'México', code: 'MX', char: '🇲🇽', region: 'mexico' },
  { name: 'Nicaragua', code: 'NI', char: '🇳🇮', region: 'nicaragua' },
  { name: 'Panamá', code: 'PA', char: '🇵🇦', region: 'panama' },
  { name: 'Paraguay', code: 'PY', char: '🇵🇾', region: 'paraguay' },
  { name: 'Perú', code: 'PE', char: '🇵🇪', region: 'peru' },
  { name: 'R. Dominicana', code: 'DO', char: '🇩🇴', region: 'dominicana' },
  { name: 'Uruguay', code: 'UY', char: '🇺🇾', region: 'uruguay' },
];

const CountrySelect = ({ countries, defaultValue, style, ...others }) => {
  const options = countries
    ? countries.map(country => {
        return {
          value: country.region,
          label: (
            <div key={country.code} className={styles.option}>
              <img
                src={country.flag}
                alt={country.name}
                className={styles.flag}
              />
              {country.name}
            </div>
          ),
        };
      })
    : countryList.map(country => {
        const Flag = Flags[country.code];
        return {
          value: country.region,
          label: (
            <div key={country.code} className={styles.option}>
              <Flag title={country.name} className={styles.flag} />
              {country.name}
            </div>
          ),
        };
      });
  const defaultCountry =
    (defaultValue && options.find(country => country.value === defaultValue)) ||
    options[0];
  const customStyles = {
    option: (provided, state) => {
      let backgroundColor = '#323437';
      if (state.isSelected) {
        backgroundColor = '#48494B';
      }
      if (state.isFocused) {
        backgroundColor = '#64686E';
      }
      return {
        ...provided,
        color: 'white',
        backgroundColor,
        padding: '0 1rem',
      };
    },
    control: base => ({
      ...base,
      background: '#323437',
      borderColor: '#323437',
      borderRadius: '0.3125rem 0.3125rem 0 0',
    }),
    menu: base => ({
      ...base,
      zIndex: 1000,
      background: '#323437',
      ...style,
    }),
    container: base => ({
      ...base,
      ...style,
    }),
  };
  const IndicatorSeparator = ({ innerProps }) => {
    return null;
  };
  return (
    <Select
      multi={false}
      defaultValue={defaultCountry}
      options={options}
      showNewOptionAtTop={false}
      isDisabled={false}
      isLoading={false}
      isClearable={false}
      isRtl={false}
      isSearchable
      styles={customStyles}
      components={{
        IndicatorSeparator,
      }}
      maxMenuHeight={1920}
      {...others}
    />
  );
};

export default CountrySelect;
